import {
  CardToEditBatchCreateRequestType,
  CardToEditBatchCreateResponseType,
  CardToEditByUserIdRequestType,
  CardToEditByUserIdResponseType,
} from "magic-shared-types";
import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    getCardToEditByUserId: builder.query<
      CardToEditByUserIdResponseType,
      CardToEditByUserIdRequestType
    >({
      query: ({ page, pageSize, status_ct, status_cm, game_id, name }) => ({
        url: `${BASE_SERVER_PATH}/api/card-to-edit/user`,
        method: "GET",
        params: { page, pageSize, status_ct, status_cm, game_id, name },
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    batchCreateCardToEdit: builder.mutation<
      CardToEditBatchCreateResponseType,
      { cards: CardToEditBatchCreateRequestType[] }
    >({
      query: (body) => ({
        url: `${BASE_SERVER_PATH}/api/card-to-edit/batch`,
        method: "POST",
        body,
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const {
  useGetCardToEditByUserIdQuery,
  useBatchCreateCardToEditMutation,
} = myServerApis;
